import React from 'react'
import "./WhyUs.css"
import WhyUsHead from './WhyUsHead'
import WhyUsMain from './WhyUsMain'

const WhyUs = () => {
  return (
    <div className='whyUsContainer'>
      <WhyUsHead/>
      <WhyUsMain/>
    </div>
  )
}

export default WhyUs
